// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + chunkId + "-" + {"53":"c6a42ff804fa728f21ac","970":"4ee364170d3ea8c55a94"}[chunkId] + ".js";
};